// Lib
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { PINTEREST } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementRateHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.pinterest.avg_engagement_rate_history',
    tooltip: 'chart.pinterest.tooltip_avg_engagement_rate_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.pinterest.avg_engagement_rate_history_name'
    },
    disableGraphData: ['count_posts'],
    id: 'average_engagement_rate_history',
    social: PINTEREST,
    color: {
        value: 'green'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
